/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as TourDataStoreActions from './tour-data-store.actions';

import { Tour, Client } from 'src/app/features/shared/models';

/* State key */
export const featureKey = 'TourDataStore';

/* State interface */
export interface TourState {
  isLoading?: boolean;
  tours?: Tour[];
  activeTour?: Tour;
  clients?: Client;
}

/* Initial values */
export const initialState: TourState = {
  isLoading: null,
  tours: null,
  activeTour: null,
  clients: null,
};

export const reducer = createReducer(
  initialState,
  on(TourDataStoreActions.GetTours, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(TourDataStoreActions.GetToursSuccessful, (state, action) => ({
    ...state,
    tours: action.payload.tours,
    isLoading: false,
  })),

  on(TourDataStoreActions.GetToursFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(TourDataStoreActions.GetTourById, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(TourDataStoreActions.GetTourByIdSuccessful, (state, action) => ({
    ...state,
    /* TODO: replace item by id from data array */
    isLoading: false,
  })),

  on(TourDataStoreActions.GetTourByIdFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(TourDataStoreActions.GetActiveTourWithRelationsById, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    TourDataStoreActions.GetActiveTourByIdWithRelationsSuccessful,
    (state, action) => ({
      ...state,
      activeTour: action.payload.activeTour,
      isLoading: false,
    }),
  ),

  on(
    TourDataStoreActions.GetActiveTourByIdWithRelationsFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(TourDataStoreActions.CreateTour, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(TourDataStoreActions.CreateTourSuccessful, (state, action) => ({
    ...state,
    tours: [...(state.tours ?? []), action.payload.tour],
    isLoading: false,
  })),

  on(TourDataStoreActions.CreateTourFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(TourDataStoreActions.UpdateTour, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(TourDataStoreActions.UpdateTourSuccessful, (state, action) => ({
    ...state,
    tours: updateEntityInArray<Tour>(
      action.payload.id,
      action.payload.data,
      state.tours ?? [],
    ),
    isLoading: false,
  })),

  on(TourDataStoreActions.UpdateTourFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(TourDataStoreActions.DeleteTour, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(TourDataStoreActions.DeleteTourSuccessful, (state, action) => ({
    ...state,
    tours: state.tours?.filter((item) => action.payload.id !== item.id) ?? [],
    isLoading: false,
  })),

  on(TourDataStoreActions.DeleteTourFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(TourDataStoreActions.ResetState, () => initialState),
);
